import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { TelegramAccount } from "../../types/telegram-page.types";
import { TelegramAccountImagesService } from "../../services/telegram-account-images.service";
import { TelegramModalsService } from "../../services/telegram-modals.service";
import { TelegramAccountsService } from "../../services/telegram-accounts.service";
import { MatMiniFabButton } from "@angular/material/button";
import { MatFormField, MatInput, MatLabel } from "@angular/material/input";
import { FormsModule } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-telegram-accounts',
  standalone: true,
  imports: [
    MatMiniFabButton,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatIcon
  ],
  templateUrl: './telegram-accounts.component.html',
  styleUrls: [
    './telegram-accounts.component.scss',
    '../telegram-components-styles.scss'
    ]
})
export class TelegramAccountsComponent implements OnInit {
  @Output() selectAccount: EventEmitter<void> = new EventEmitter<void>();

  private telegramAccountImagesService: TelegramAccountImagesService = inject(TelegramAccountImagesService);
  private telegramModalsService: TelegramModalsService = inject(TelegramModalsService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);

  public searchAccount: string = '';
  public isVisibleAccounts: boolean = true;
  public searchAccounts: Array<TelegramAccount> = [];

  public async ngOnInit(): Promise<void> {
    await this.getAccounts();
  }

  public loadAccounts(): void {
    const searchTerm = this.searchAccount?.toLowerCase().trim() || '';
    this.searchAccounts = searchTerm
      ? this.telegramAccountsService.accounts().filter(account => account.accountName.toLowerCase().includes(searchTerm))
      : this.telegramAccountsService.accounts();
  }

  public handleSelectAccount(account: TelegramAccount): void {
    this.telegramAccountsService.setSelectedAccount(account);
    this.selectAccount.emit();
  }

  public toggleAccount(): void {
    this.isVisibleAccounts = !this.isVisibleAccounts;
  }

  public isChatActive(account: TelegramAccount): boolean {
    return this.telegramAccountsService.selectedAccount() === account;
  }

  public getImage(id: string): string {
    return this.telegramAccountImagesService.getAccountImage(id);
  }

  public async handleUpdatePhoto(account: TelegramAccount) {
    const result = await this.telegramModalsService.openTelegramUpdateAccountPhotoModal(account.accountId);
    if (result === 'success') {
      await this.getAccounts();
      const updateAccount = this.telegramAccountsService.accounts().find(item => item.accountId === account.accountId)
      updateAccount &&  await this.telegramAccountImagesService.setImageUrls(updateAccount, true);
    }
  }

  private async getAccounts(): Promise<void> {
    await this.telegramAccountsService.loadAccounts();
    this.loadAccounts();
    this.telegramAccountImagesService.loadAccountPhotos(this.telegramAccountsService.accounts());
  }
}
